// extracted by mini-css-extract-plugin
export default {"section":"page_section__v1w5n","sub_heading":"page_sub_heading__vAm6L","ul":"page_ul__WHzG4","contact":"page_contact__EnJMT"};